import { type Event } from 'models';
import type Poll from 'models/poll';
import { type TodoDataObject } from './todoDataObject';

// TODO have a look at these types and consider rework
export class Todo {
  id: string;
  startTime: Date;
  endTime: Date;
  path: string;
  withingsOrderPost?: TodoWithingsOrderPost;
  event?: Partial<Event>;
  poll?: Partial<Poll>;
  activity?: TodoActivity;

  constructor(data: TodoDataObject) {
    this.id = data.id;
    this.startTime = new Date(data.start_time);
    this.endTime = new Date(data.end_time);
    this.path = data.path;
    this.withingsOrderPost = data.withings_order_post
      ? {
          id: data.withings_order_post.id,
          textContent: data.withings_order_post.text_content,
        }
      : undefined;
    this.event = data.event
      ? {
          id: data.event.id,
          name: data.event.name,
          currentUserRsvp: data.event.current_user_rsvp,
        }
      : undefined;
    this.poll = data.poll
      ? {
          id: data.poll.id,
          description: data.poll.description,
        }
      : undefined;
    this.activity = data.activity
      ? {
          id: data.activity.id,
          name: data.activity.name,
          periodicityType: data.activity.periodicity_type,
          times: data.activity.times,
        }
      : undefined;
  }
}

type TodoActivity = {
  id: string;
  name: string;
  periodicityType: 'annually' | 'daily' | 'monthly' | 'one-time' | 'quarterly' | 'weekly';
  times: string[];
};

type TodoWithingsOrderPost = {
  id: string;
  textContent: string;
};
